import React, { useEffect, useRef } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import { Container } from "reactstrap";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "routes.js";
import Tables from "views/examples/Solicitudes";
import logo from "../assets/img/brand/LOGO-Icontec-2019_hor_pos (1).png";
import Cookies from "universal-cookie";

const Admin = (props) => {
  const cookie = new Cookies();
  const mainContent = useRef(null);
  const location = useLocation();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return <Route path={prop.path} element={prop.component} key={key} />;
      }
      return null;
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (path.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          innerLink: "/admin/Solicitudes",
          imgSrc: logo,
          imgAlt: "Logo",
          width: "600px", // Ajusta el ancho al tamaño deseado
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar {...props} brandText={getBrandText(location.pathname)} />
        <Routes>
          {getRoutes(routes)}
          <Route
            path="*"
            element={
              <Navigate
                to={`/admin/Solicitudes/${cookie.get("correo")}`}
                replace
              />
            }
          />
          <Route path="/admin/Solicitudes/:id" element={<Tables />} />
        </Routes>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default Admin;
